import React from 'react'
import "./styles/selectboard.css"

function SelectBoard() {
  return (
    <div className="ss">
    <div className='selectboard-container'>
        <p>please select a board to delete!</p>
    </div>
    </div>
  )
}

export default SelectBoard